// DraggableViewer.js
import React, { useRef, useState } from "react";
import { Paper, Dialog, DialogTitle, styled } from "@mui/material";
import { AppStyle } from "../value/AppConst";

const ClassDraggableTitle = 'draggable-title-for-viewer';

const ViewerTitle = styled(DialogTitle)({
    backgroundColor: AppStyle.SuccessRGB, color: 'white', minWidth: 300, display: 'flex', alignItems: 'center',
    cursor: 'move'
});

const IconBox = styled('div')({
    marginRight: 10,
});

const DraggablePaper = (props) => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [dragging, setDragging] = useState(false);
    const dragRef = useRef(null);

    const onMouseDown = (e) => {
        if(e.target.closest(`.${ClassDraggableTitle}`)) {
            setDragging(true);
            dragRef.current = {
                offsetX: e.clientX - position.x,
                offsetY: e.clientY - position.y,
            };
        }
    };

    const onMouseMove = (e) => {
        if (dragging) {
            setPosition({
                x: e.clientX - dragRef.current.offsetX,
                y: e.clientY - dragRef.current.offsetY,
            });
        }
    };

    const onMouseUp = () => {
        setDragging(false);
    };

    const childrenArray = props.children.props.children;

    return (
        <Paper
            {...props}
            style={{
                transform: `translate(${position.x}px, ${position.y}px)`
            }}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
        >
            <div className={ClassDraggableTitle}
                onMouseDown={onMouseDown}
                style={{cursor: 'move'}}
            >
                {childrenArray[0]}
            </div>
            {childrenArray.slice(1)}
        </Paper>
    );
};

export default function DraggableViewer({
    children,
    open,
    onClose, 
    startIcon,
    title,
    maxWidth='lg',
    style,
    fullScreen=false
}) {
    if(!open) return null;

    return(
        <Dialog open={open} onClose={()=>{ if(onClose) onClose(); }}
            maxWidth={maxWidth}
            PaperComponent={DraggablePaper}
            fullScreen={fullScreen}
        >
            <ViewerTitle style={style}>
                {
                    startIcon && (
                        <IconBox>
                            {startIcon}
                        </IconBox>
                    )
                }
                <div>{title}</div>
            </ViewerTitle>
            {children}
        </Dialog>
    );
}